import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const tooltipArrowStyle = css`
  background-color: ${theme.colors.white};
  color: ${theme.colors.neutral50};
  && .tooltip-floating-arrow {
    fill: ${theme.colors.white};
  }
`;

export const upgradeButtonStyle = css`
  padding: 0;
  background-color: transparent;
  &:hover {
    background-color: transparent;
  }
`;

export const nakedButtonStyle = (isSelected: boolean) => css`
  display: flex;
  width: 100%;
  padding: ${theme.spacing(2, 3)};
  border-bottom: 1px solid ${theme.colors.neutral10};
  gap: ${theme.spacing(1)};
  align-items: center;
  transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  box-shadow: ${isSelected ? `inset 4px 0px ${theme.colors.primary50}` : 'none'};

  &:not(:disabled):hover {
    background-color: ${theme.colors.neutral5};
  }

  &:not(:disabled):focus {
    background-color: ${theme.colors.neutral5};
    outline: 2px solid ${theme.colors.primary50};
  }
`;

export const textStyle = css`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
